define('collections/Podio.Collections.Files',['require','lib/backbone/Backbone.PodioScrollPaginatedCollection','lib/Podio.Routes','models/Podio.Models.File'],function(require) {

  var PodioScrollPaginatedCollection = require('lib/backbone/Backbone.PodioScrollPaginatedCollection');
  var routes = require('lib/Podio.Routes');

  return PodioScrollPaginatedCollection.extend({

    configure: function() {
      this.model = require('models/Podio.Models.File');
    },

    initialize: function(models, options) {
      if (options && options.filterState) {
        this.filterState = options.filterState;
        this.filterState.bind('filtersUpdated', this.getItems, this);
      }
      this.url = routes.isOnSpaceLevel ? routes.space_files_with_current_space_path({ format: 'json' }) : routes.files_path({ format: 'json' });
    },

    getItems: function() {
      this.fetchData = this.filterState.toJSON();
      this.getPage(1, {
        data: this.fetchData
      });
    }

  });

});






